import { useEffect, useRef, useState } from 'react';
import { getComparison } from './documentCompareApi';
import { RUNNING, errorOf } from './compareFormat';

const POLL_MS = 3000;
const MAX_POLL_MS = 30000;

// Follow a running comparison until it is done. A failed poll is retried (slower
// each time) instead of stopping; an answer arriving after the user opened another
// comparison, or closed the screen, is dropped. Returns resetFailures for when the
// user opens another comparison.
const useComparisonPolling = ({ active, current, onUpdate, onError }) => {
  const [pollTick, setPollTick] = useState(0);
  const failures = useRef(0);

  useEffect(() => {
    if (!active || !current || !RUNNING.includes(current.status)) return undefined;
    let stale = false;
    const delay = Math.min(POLL_MS * 2 ** failures.current, MAX_POLL_MS);
    const timer = setTimeout(async () => {
      try {
        const res = await getComparison(current.id);
        if (stale) return;
        failures.current = 0;
        onError('');
        onUpdate(res.data);
      } catch (e) {
        if (stale) return;
        failures.current += 1;
        onError(errorOf(e, 'Lost track of the comparison — retrying…'));
        setPollTick((n) => n + 1);
      }
    }, delay);
    return () => { stale = true; clearTimeout(timer); };
  }, [active, current, pollTick, onUpdate, onError]);

  return { resetFailures: () => { failures.current = 0; } };
};

export default useComparisonPolling;
